<template>
  <div v-if="$store.state.isUserLoggedIn">
    <v-app-bar app fixed color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <img :src="logo" height="38px" />

      <v-spacer></v-spacer>

      <!-- <v-avatar>
        <img :src="picture" :alt="user.fullName + ' image'" />
      </v-avatar> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon dark>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click.stop="editItem">
            <v-list-item-action>
              <v-icon>mdi-wrench</v-icon>
            </v-list-item-action>
            <v-list-item-title>Edit Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logOut">
            <v-list-item-action>
              <v-icon>mdi-power</v-icon>
            </v-list-item-action>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>

          <v-list-item
            v-else-if="adminDisplay"
            :key="item.text"
            :to="item.link"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="user.firstName"
                  label="First Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="user.lastName"
                  label="Last Name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="qrDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">QR Code</span>
        </v-card-title>

        <v-card-text>
          <v-container style="text-align: center;">
            <v-layout wrap>
              <v-flex xs12 sm12>
                <qrcode-vue
                  :value="user.fullName"
                  :size="size"
                  level="H"
                ></qrcode-vue>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UserProfile
      :visible="showUserProfile"
      :item="profile"
      @close="closeThis"
    />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import UserProfile from '../forms/UserProfile'

export default {
  components: {
    QrcodeVue,
    UserProfile,
  },

  data: () => ({
    showUserProfile: false,
    profile: {},
    dialog: false,
    qrDialog: false,
    drawer: null,
    size: 250,
    items: [
      { icon: 'mdi-view-dashboard', text: 'Dashboard', link: '/' },
      // {
      //   icon: 'mdi-file-multiple',
      //   text: 'Documents',
      //   link: '/document',
      // },
      {
        icon: 'mdi-account-group',
        text: 'Consortia',
        link: '/consortia',
      },
      {
        icon: 'mdi-card-account-details',
        text: 'Companies',
        link: '/companies',
      },
      {
        icon: 'mdi-currency-usd',
        text: 'Billing',
        link: '/billing',
      },
      // { icon: 'calendar_today', text: 'Calendar', link: '/calendar' },
      // { icon: 'mdi-dog', text: 'Animals 2', link: '/table3' },
      // { icon: 'child_care', text: 'Animals 3', link: '/table4' },
      {
        icon: 'mdi-cog',
        text: 'Settings',
        link: '/settings',
      },
      // { icon: 'help', text: 'Help' }
    ],
    configs: [
      { icon: 'mdi-wrench', title: 'Edit Profile', action: 'editItem' },
      { icon: 'mdi-power', title: 'Logout', action: 'logOut' },
    ],
  }),

  props: {
    source: String,
  },

  beforeMount() {},

  computed: {
    user() {
      return this.$store.state.user
    },
    page() {
      return this.$store.state.currentPage
    },
    logo() {
      return '/img/logo.png'
    },
    picture() {
      return (
        process.env.VUE_APP_ENV_API +
        '/images/members/' +
        this.$store.state.user.image
      )
    },
    adminDisplay() {
      // console.log('item', this.items.admin)

      if (!this.items.admin) {
        return true
      } else if (this.items.admin && this.$store.state.isAdmin) {
        return true
      } else {
        return false
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    qrDialog(val) {
      val || this.close()
    },
  },

  methods: {
    editItem() {
      this.profile = this.$store.state.user
      this.showUserProfile = true
    },

    closeThis() {
      this.showUserProfile = false
    },

    logOut() {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setDemoEmail', null)
      this.$store.dispatch('setUser', null)
      this.$store.dispatch('setClient', null)
      this.$store.dispatch('setCurrentYear', 0)
      this.$router.push({
        name: 'login',
      })
    },
    changeMini() {
      this.user.mini = !this.user.mini
      this.$store.dispatch('setMini', this.user.mini)
    },

    close() {
      this.dialog = false
      this.qrDialog = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
  },
}
</script>

<style scoped></style>
